import {
  Category,
  NavigationData,
  NavigationItemType,
  Report,
} from 'core/slices/models';
import { isCategoryActive } from './isCategoryActive';

/**
 * Get the category is active based on the active report
 * @param navigationData
 * @param activeReport
 */
export const getActiveCategoryByActiveReport = (
  navigationData: NavigationData | null,
  activeReport: Report
) => {
  if (!activeReport || !navigationData?.children) {
    // Also check if children exist
    return null;
  }

  return navigationData.children.find(elem => {
    if (elem.nodeType === NavigationItemType.CATEGORY) {
      return isCategoryActive(elem as Category, activeReport);
    }
    return false; // Important: explicitly return false for non-matching elements
  }) as Category | undefined; // Cast the result to Category or undefined
};
